import { render } from "./FeeLabel.vue?vue&type=template&id=649798ee"
import script from "./FeeLabel.vue?vue&type=script&lang=js"
export * from "./FeeLabel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__